import { IEnhancedDropDown, IEnhancedDropDownItem } from "@websential/cosmic-v20";

import { ProcessPayrollDropDown } from "./ProcessPayrollDropDown";
import React from "react";
import { useController } from "react-hook-form";

export interface IEnhancedDropDownRHF
  extends Pick<
    IEnhancedDropDown,
    Exclude<
      keyof IEnhancedDropDown,
      "onChangeHandler" | "isMulti" | "helperText"
    >
  > {
  onSelectionChangeHandler?: (item: IEnhancedDropDownItem | any) => void;
  // resetSelection?: boolean;
}

/**
 * React Hook Form Drop Down component.
 */
export const ProcessPayrollDropDownRHF: React.FC<IEnhancedDropDownRHF> = ({
  selectName,
  selectedItem,
  showEmpty,
  isDisabled = false,
  isHide = false,
  // resetSelection = false,
  items,
  testId,
  isSearchable,
  onSelectionChangeHandler,
}) => {
  const {
    field: { onChange, value },
    formState: { errors },
  } = useController({
    name: selectName,
    defaultValue: selectedItem,
  });

  const onDDLChange = (choosedItem: IEnhancedDropDownItem | any) => {
    if (choosedItem) {
      onChange(choosedItem.value);
      if (onSelectionChangeHandler) {
        onSelectionChangeHandler(choosedItem);
      }
    } else {
      onChange(null);
      if (onSelectionChangeHandler) {
        onSelectionChangeHandler(null);
      }
    }
  };

  return (
    <ProcessPayrollDropDown
      items={items}
      selectedItem={value}
      showEmpty={showEmpty}
      testId={testId}
      selectName={selectName}
      isDisabled={isDisabled}
      isHide={isHide}
      isSearchable={isSearchable}
      onChangeHandler={(val:any) => onDDLChange(val)}
      helperText={errors[selectName]?.message}
    />
  );
};
